import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var allDepositsParams = function allDepositsParams(data) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (data === null || data === void 0 ? void 0 : data.pageSize) && {
    per_page: data === null || data === void 0 ? void 0 : data.pageSize
  }), (data === null || data === void 0 ? void 0 : data.pageIndex) && {
    page: (data === null || data === void 0 ? void 0 : data.pageIndex) + 1
  }), (data === null || data === void 0 ? void 0 : data.franchisee) && {
    franchisee_id: data === null || data === void 0 ? void 0 : data.franchisee
  }), (data === null || data === void 0 ? void 0 : data.office) && {
    office_id: data === null || data === void 0 ? void 0 : data.office
  }), (data === null || data === void 0 ? void 0 : data.startDate) && {
    date_from: data === null || data === void 0 ? void 0 : data.startDate
  }), (data === null || data === void 0 ? void 0 : data.endDate) && {
    date_to: data === null || data === void 0 ? void 0 : data.endDate
  }), (data === null || data === void 0 ? void 0 : data["export"]) && {
    "export": data === null || data === void 0 ? void 0 : data["export"]
  });
};